export { SalaryReport } from '@app/pages/Analytics/SalaryReport/ui';
